import { fetchData, postData, putData } from 'modules/Axios';
import { showToast } from 'modules/Notifications';

export const defaultState = {
  integration: null,
  destinations: {},
};

export const initEditIntegration = (id) => {
  return async (dispatch, getState) => {
    const { brand } = getState().app;
    const URL = `brands/${brand.id}/integrations/${id}`;
    const integration = await dispatch(fetchData(URL))
      .catch(e => {
        dispatch(showToast({
          state: 'ERROR',
          title: 'Error',
          message: e.message,
          dismissible: true,
          dismissAfter: 1500,
        }));
        return defaultState.integration;
      });
      dispatch(updateIntegration(integration))
      await dispatch(getDestinations())
     return integration;
  };
};

export const UPDATE_INTEGRATION = 'UPDATE_INTEGRATION';
export const updateIntegration = integration => ({
  type: UPDATE_INTEGRATION,
  payload: integration,
});

export const saveIntegration = (integrationDTO, id) => {
  return async (dispatch, getState) => {
    const { brand } = getState().app;
    const integration = await dispatch(putData(`brands/${brand.id}/integrations/${id}`, { ...integrationDTO }))
      .catch(e => {
        console.log('API Call to create integration failed...', e);
        dispatch(showToast({
          state: 'ERROR',
          title: 'Error',
          message: 'Issue creating the integration. Please try again later',
          dismissible: true,
          dismissAfter: 1500,
        }));
        return defaultState.integration;;
      });

      if (integration) {
        dispatch(showToast({
          state: 'SUCCESS',
          title: 'Success',
          message: 'Integration Updated Successfully',
          dismissible: true,
          dismissAfter: 2000,
        }));
        dispatch(updateIntegration(integration))
      return integration;
      }
  };
};

export const GET_DESTINATIONS = 'GET_DESTINATIONS';

export const getDestinations = () => {
  return async (dispatch, getState) => {
    const { brand } = getState().app;
    const URL = `/brands/${brand.id}/audiences/destinations`;
    try {
      const destinations = await dispatch(fetchData(URL));
      dispatch({type: GET_DESTINATIONS, payload: destinations});
    } catch (e) {
      console.log('API Call to /integrationTypes failed...', e);
      dispatch(showToast({
        state: 'ERROR',
        title: 'Error',
        message: 'Issue retrieving integration types list. Please try again later',
        dismissible: true,
        dismissAfter: 1500,
      }));
    }
  };
};

export const saveSshFile = (fileData, updateFileUploadingProgress) => {
  return async (dispatch, getState) => {
    const { brand } = getState().app;
    try {
      const getSshKeyId = await dispatch(postData(`brands/${brand.id}/integrations/ssh_keys`, fileData, null, true, 'json', updateFileUploadingProgress));
      return getSshKeyId;
    } catch (e) {
      console.log('API Call to upload audience file failed...', e);
      dispatch(showToast({
        state: 'ERROR',
        title: 'Error',
        message: 'Issue uploading audience file. Please try again later',
        dismissible: true,
        dismissAfter: 1500,
      }));
      return null;
    }
  };
};

export const saveEncryptionFile = (fileData, updateFileUploadingProgress) => {
  return async (dispatch, getState) => {
    const { brand } = getState().app;
    try {
      const getEncryptionKeyId = await dispatch(postData(`brands/${brand.id}/integrations/encryption_keys`, fileData, null, true, 'json', updateFileUploadingProgress));
      return getEncryptionKeyId;
    } catch (e) {
      console.log('API Call to upload audience file failed...', e);
      dispatch(showToast({
        state: 'ERROR',
        title: 'Error',
        message: 'Issue uploading audience file. Please try again later',
        dismissible: true,
        dismissAfter: 1500,
      }));
      return null;
    }
  };
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case UPDATE_INTEGRATION:
      return {
        ...state,
        integration: action.payload,
      };
    case GET_DESTINATIONS:
      return {
        ...state,
        destinations: action.payload,
      };
    default:
      return state;
  }
}
